import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import {
  GetAddonsParam,
  GetPincodeListingParams,
  QuotationGetRequestParam,
  QuotationRequest,
  GetInsurerListingParams,
  GetMiscellaneousListingParams,
  GetInsuranceListingParams
} from 'Models/RequestModels/Health'
import {
  GetAddonRidersListing,
  GetPincodeListingResponse,
  GetQuestionsListingResponse,
  QuotationGetResponse,
  QuotationPostResponse,
  GetInsurerListingResponse,
  GetMiscellaneousListing,
  GetInsuranceListingResponse,
  GetGenericBenefitsListingResponse,
  ProposalPostResponse,
  ProposalRequest,
} from 'Models/ResponseModels/Health'
import { baseUrlHealthQuery } from 'Services/baseQuery'

// const getHealthHeaders = () => {
//   const tempHeaders = { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' }
//   // if (token) {
//   return {
//     ...tempHeaders,
//     Authorization: 'Token f22ea5d8f5615b76b901026a8c051f0758d1be81',
//   }
//   // }
//   // return tempHeaders
// }

export const healthApi = createApi({
  reducerPath: 'healthApi',
  baseQuery: baseUrlHealthQuery,
  endpoints: (builder) => ({
    getSubRequest: builder.mutation<QuotationPostResponse, QuotationRequest>({
      query: (body: QuotationRequest) => ({
        url: API_ENDPOINTS.HEALTH_QUOTATION,
        method: 'POST',
        body: body,
        // headers: getHealthHeaders(),
      }),
    }),
    getPollingQuotations: builder.query<QuotationGetResponse, QuotationGetRequestParam>({
      query: ({ sub_request_id }) => ({
        url: API_ENDPOINTS.HEALTH_QUOTATION,
        method: 'GET',
        params: {
          sub_request_id,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getAddons: builder.query<GetAddonRidersListing[], GetAddonsParam>({
      query: ({ insurance_id, plan_type }) => ({
        url: API_ENDPOINTS.HEATH_ADDONS,
        method: 'GET',
        params: {
          insurance_id,
          plan_type,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getPincodeListing: builder.query<GetPincodeListingResponse, GetPincodeListingParams>({
      query: ({ insurer, pincode }) => ({
        url: API_ENDPOINTS.HEALTH_PINCODE,
        method: 'GET',
        params: {
          insurer,
          pincode,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getGenericSumInsured: builder.query<string[], void>({
      query: () => ({
        url: API_ENDPOINTS.HEALTH_SUMINSURED_GENRIC,
        method: 'GET',
        // headers: getHealthHeaders(),
      }),
    }),
    getInsurerListingPlans: builder.query<GetInsurerListingResponse[], GetInsurerListingParams>({
      query: ({ is_previous_insurer }) => ({
        url: API_ENDPOINTS.HEALTH_INSURER_LISTING,
        method: 'GET',
        params: {
          is_previous_insurer,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getQuestionListing: builder.query<GetQuestionsListingResponse[], { insurance_id: string }>({
      query: ({ insurance_id }) => ({
        url: API_ENDPOINTS.HEALTH_QUES,
        method: 'GET',
        params: {
          insurance_id,
        },
        // headers: getHealthHeaders(),
      }),
    }),
    getMiscellaneousListing: builder.query<GetMiscellaneousListing, GetMiscellaneousListingParams>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_LIST_MISCELLANEOUS,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    getInsuranceListing: builder.query<GetInsuranceListingResponse[], GetInsuranceListingParams>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_INSURANCE_LISTING,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    getGenericBenefitsListing: builder.query<GetGenericBenefitsListingResponse[], void>({
      query: (params) => ({
        url: API_ENDPOINTS.HEALTH_BENEFITS,
        method: 'GET',
        params: params,
        // headers: getHealthHeaders(),
      }),
    }),
    createProposal: builder.mutation<ProposalPostResponse, ProposalRequest>({
      query: (body: ProposalRequest) => ({
        url: API_ENDPOINTS.HEALTH_PROPOSAL,
        method: 'POST',
        body: body,
        // headers: getHealthHeaders(),
      }),
    }),
  }),
})

export const {
  useGetSubRequestMutation,
  useGetPollingQuotationsQuery,
  useGetAddonsQuery,
  useGetPincodeListingQuery,
  useGetGenericSumInsuredQuery,
  useGetInsurerListingPlansQuery,
  useGetQuestionListingQuery,
  useGetMiscellaneousListingQuery,
  useLazyGetPincodeListingQuery,
  useGetInsuranceListingQuery,
  useGetGenericBenefitsListingQuery,
  useCreateProposalMutation,
} = healthApi
